import { DirectionalHeatmapControl } from "../controls/DirectionalHeatmapControl";
import { DataSourceControl } from "../controls/DataSourceControl";
import {
  getDirectionalLayers,
  SPEED_BREAKPOINTS,
} from "../layers/DirectionalLayers";
import { interpolatedSpeedFromColor } from "../layers/style/util/colorScale";
import {
  registerHeatmapControl,
  registerDataSourceControl,
  getFCDToggleFromURL,
  getFCDModeFromURL,
  getFCDDirectionsFromURL,
  getFCDDataSourceFromURL,
} from "../state/URLStateManager";

export function addHeatmapLayersAndControls(
  map,
  azureLoginControl,
  dateInputControl,
  target,
  layerGroup,
  featureInfoControl,
) {
  // Heatmap layer Controls
  const directionalHeatmapControl = new DirectionalHeatmapControl({
    target: target,
  });
  const dataSourceControl = new DataSourceControl({
    target: target,
  });
  map.addControl(directionalHeatmapControl);
  map.addControl(dataSourceControl);

  directionalHeatmapControl.restoreState(
    getFCDToggleFromURL(),
    getFCDModeFromURL(),
    getFCDDirectionsFromURL(),
  );
  registerHeatmapControl(directionalHeatmapControl);

  const fcdDataSource = getFCDDataSourceFromURL();
  if (fcdDataSource != null) {
    dataSourceControl.set("dataSource", fcdDataSource);
  }
  registerDataSourceControl(dataSourceControl);

  let directionalLayers;
  azureLoginControl.on("propertychange", function () {
    if (directionalLayers) {
      directionalLayers.forEach(function (layer) {
        map.removeLayer(layer);
      });
    }

    if (
      azureLoginControl.get("idToken") &&
      azureLoginControl.get("idTokenClaims") &&
      azureLoginControl.get("idTokenClaims").roles &&
      azureLoginControl.get("idTokenClaims").roles.includes("FCD.Reader")
    ) {
      directionalLayers = getDirectionalLayers(
        dateInputControl,
        azureLoginControl,
        dataSourceControl,
        directionalHeatmapControl,
      );
      directionalHeatmapControl.set("directionalLayers", directionalLayers);
      directionalLayers.forEach(function (layer) {
        layerGroup.getLayers().push(layer);
      });
    }
  });
  map.on("moveend", function () {
    directionalHeatmapControl.set("zoom", map.getView().getZoom());
    dataSourceControl.set("zoom", map.getView().getZoom());
  });

  let hoverFrame = null;
  let lastSpeedsKey = null;
  map.on("pointermove", function (e) {
    if (e.dragging || e.originalEvent.target.tagName !== "CANVAS") return;
    if (hoverFrame !== null) return;
    hoverFrame = requestAnimationFrame(function () {
      hoverFrame = null;
      const inSpeedMode =
        directionalHeatmapControl.get("displayMode") === "speed";
      const fcdOn = directionalHeatmapControl.get("heatmapToggle") === true;
      const active = directionalHeatmapControl.get("active") === true;
      let speeds = null;
      if (inSpeedMode && fcdOn && active && directionalLayers) {
        const sampled = {};
        directionalLayers.forEach(function (layer, id) {
          if (!layer.getVisible() || layer.getOpacity() === 0) return;
          const data = layer.getData(e.pixel);
          if (!data || data[3] === 0) return;
          sampled[id] = interpolatedSpeedFromColor(
            [data[0], data[1], data[2]],
            SPEED_BREAKPOINTS,
          );
        });
        if (Object.keys(sampled).length > 0) speeds = sampled;
      }
      const key =
        speeds === null
          ? null
          : Object.keys(speeds)
              .map(Number)
              .sort((a, b) => a - b)
              .map((id) => id + ":" + speeds[id])
              .join(",");
      if (key === lastSpeedsKey) return;
      lastSpeedsKey = key;
      featureInfoControl.set("fcdSpeeds", speeds);
    });
  });
}
